import { useCallback, useEffect, useReducer } from 'react';

const INITIAL = {
  amount: 5000,
  provider: 'wave',
  donorName: '',
  donorPhone: '',
  message: '',
  anonymous: false,
  isPrivate: false,
  success: false,
};

function reducer(state, action) {
  switch (action.type) {
    case 'set':
      return { ...state, [action.key]: action.value };
    case 'reset':
      return { ...INITIAL };
    case 'success':
      return { ...state, success: true };
    default:
      return state;
  }
}

export function useDonationState(open) {
  const [state, dispatch] = useReducer(reducer, INITIAL);

  const setValue = useCallback((key, value) => dispatch({ type: 'set', key, value }), []);
  const markSuccess = useCallback(() => dispatch({ type: 'success' }), []);
  const resetState = useCallback(() => dispatch({ type: 'reset' }), []);

  useEffect(() => {
    if (open) resetState();
  }, [open, resetState]);

  return { state, setValue, markSuccess };
}
